require('./lbDateSelect.scss');

const $inject = [];

const lbDateSelect = {
  controller: 'lbDateSelectCtrl as vm',
  template: require('./lbDateSelect.html'),
  bindings: {
    name: '@',
    date: '=',
    min: '<',
    max: '<',
    rangeFrom: '<',
    rangeTo: '<',
    required: '<',
    disabled: '<'
  }
};

lbDateSelect.$inject = $inject;

export default lbDateSelect;




// WEBPACK FOOTER //
// ./src/components/lbDateSelect/lbDateSelect.js